export const CHANGE_SALES_REP = 'CHANGE_SALES_REP'
export const CHANGE_STATUS = 'CHANGE_STATUS'
export const EDIT_EVENT = 'EDIT_EVENT'
export const RESEND_EMAILS = 'RESEND_EMAILS'
export const SCHEDULE_FOR_EXPORT = 'SCHEDULE_FOR_EXPORT'
export const SET_TO_RE_EXPORT = 'SET_TO_RE_EXPORT'
export const UPDATE_ORDER_PRICING = 'UPDATE_ORDER_PRICING'
export const DUPLICATE_ORDERS = 'DUPLICATE_ORDERS'
export const MARK_AS_EXPORTED = 'MARK_AS_EXPORTED'
export const ASSIGN_RETAILER_ACCOUNT = 'ASSIGN_RETAILER_ACCOUNT'
export const SEND_INVOICE = 'SEND_INVOICE'
export const REMOVE_STYLE_COLORS_WITH_NO_QUANTITIES =
  'REMOVE_STYLE_COLORS_WITH_NO_QUANTITIES'
export const MERGE_ORDERS = 'MERGE_ORDERS'
export const SEND_TO_ASSORTMENT = 'SEND_TO_ASSORTMENT'
